// extracted by mini-css-extract-plugin
module.exports = {"root":"OutsideClickHandler_root__3h88O"};